export default __webpack_public_path__ + "static/media/global-icon-two.cb7f386e.svg";